package music.jammers.client.shared.auth.domain.usecase

import music.jammers.client.shared.auth.domain.repository.AuthRepository
import music.jammers.client.shared.auth.domain.repository.TokenRepository
import music.jammers.shared.auth.domain.model.Token
import music.limasoul.client.shared.user.domain.repository.UserRepository

class LoginUseCase(
    private val tokenRepository: TokenRepository,
    private val userRepository: UserRepository,
    private val authRepository: AuthRepository,
) {

    suspend operator fun invoke(firebaseToken: String) {
        val tokenModel = Token(firebaseToken)

        val token = authRepository.login(tokenModel)
        tokenRepository.save(token)
        userRepository.getCurrent()
    }
}